export const Milestones = {
  ES: {
    Educación: [
      {
        title: "The Odin Project - Full Stack Ruby on Rails and NodeJS",
        url: "https://www.theodinproject.com/paths/full-stack-ruby-on-rails?",
        start: "2020",
        end: "2021",
        list: [
          {
            title: "Skills",
            structure: ["Ruby/Rails", "HTML/CSS", "Javascript/NodeJs"],
          },
        ],
        area: "programming",
      },
      {
        title: "The Fundamentals of Database Engineering",
        url: "https://www.udemy.com/course/database-engines-crash-course/",
        start: "Jul 2023",
        end: "Ago 2023",
        area: "programming",
        list: [
          {
            title: "Skills",
            structure: [
              "ACID, Indexing, Partitioning, Sharding, Concurrency control, Replication, DB Engines y buenas prácticas",
            ],
          },
        ],
      },
      {
        title: "The Fundamentals of Backend",
        url: "https://www.udemy.com/share/107rGq3@UAyCjZcRsfXDZxTZVbto0WnAstH9dDLXIpN0gpKt3wfaeDMDiPH6-k8cH4xkxHt1qw==/",
        start: "Jun 2023",
        end: "Jul 2023",
        area: "programming",
        list: [
          {
            title: "Skills",
            structure: [
              "Entender patrones de diseño de comunicación backend, protocolos, ejecución y proxying",
            ],
          },
        ],
      },
      {
        title: "AI Automation: Build LLM Apps & AI-Agents with n8n & APIs",
        url: "https://www.udemy.com/course/ai-automation-build-llm-apps-ai-agents-with-n8n-apis/?srsltid=AfmBOopEr3WXDAdCxJ2mk36YT9JF2RCqkQvrL_OBjCp7kF9jhJ7CDDdR",
        start: "Jun 2024",
        end: "Jul 2024",
        area: "programming",
        list: [
          {
            title: "Skills",
            structure: [
              "Fundamentos de Automatización, n8n, Integraciones con APIs, Creación de Apps con LLMs, Desarrollo de AI-Agents",
            ],
          },
        ],
      },
      {
        title: "Ingeniería Mecánica - Universidad Tecnológica Nacional",
        start: "2007",
        end: "2012",
        description: "Cursado hasta 4to año de la carrera.",
        area: "mechanics",
        list: [
          {
            title: "Materias básicas aprobadas",
            structure: [
              "Análisis Matemático I y II",
              "Álgebra y Geometría Analítica",
              "Cálculo Avanzado",
              "Física I y II",
              "Probabilidad y Estadística",
              "Química General y Aplicada",
            ],
          },
          {
            title: "Materias de la especialidad aprobadas",
            structure: [
              "Ingeniería Mecánica I, II y III",
              "Sistemas de Representación",
              "Estabilidad I",
              "Materiales Metálicos",
              "Ing Ambiental y Seguridad Industrial",
              "Térmodinámica",
              "Diseño Mecánico",
            ],
          },
        ],
      },
      {
        title:
          "Bachiller en Gestión de las Organizaciones - Colegio Santo Tomás",
        start: "1994",
        end: "2006",
        area: "school",
      },
    ],
    Experiencia: [
      {
        title: "Freelance - Fullstack Developer",
        start: "Ene 2025",
        end: "presente",
        area: "programming",
        list: [
          {
            title: "Principales logros",
            structure: [
              "Desarrollo de aplicación en Ruby on Rails desde cero para gestionar equipos industriales y servicios de mantenimiento",
              "Manejo de despliegue, monitoreo y mantenimiento continuo",
              "Trabajo directo con stakeholders para recopilar requisitos e iterar sobre funcionalidades",
            ],
          },
        ],
      },
      {
        title: "GoCuotas - Desarrollador BackEnd",
        start: "Feb 2024",
        end: "Nov 2024",
        area: "programming",
        list: [
          {
            title: "Principales logros",
            structure: [
              "Implementación del seguimiento del ciclo de vida del usuario (onboarding, activo, inactivo) para usuarios administradores",
              "Integración y personalización de flujos de chatbots de soporte al cliente basados en el contexto del usuario",
              "Colaboración con los equipos de producto y soporte para mejorar el compromiso del usuario",
            ],
          },
        ],
      },
      {
        title: "WISBOO - Desarrollador BackEnd",
        start: "Sep 2022",
        end: "Jun 2023",
        area: "programming",
        list: [
          {
            title: "Principales logros",
            structure: [
              "Mejora de los tiempos de respuesta de la API en un 80-90% mediante la optimización de consultas a la base de datos",
              "Identificación de cuellos de botella en el rendimiento y refactorización de partes críticas de la aplicación",
              "Uso de Datadog para analizar logs, errores y latencia de endpoints",
            ],
          },
        ],
      },
      {
        title: "Independiente - Programador CNC / Diseñador CAD/CAM",
        start: "2017",
        end: "2021",
        area: "mechanics",
      },
      {
        title: "IMAPRO SRL / MetalCast - Encargado de planta",
        start: "2007",
        end: "2017",
        area: "mechanics",
        list: [
          {
            title: "Programacion CNC",
            structure: [
              "Fresa CNC Fagor",
              "Programación a pie de máquina",
              "Programación CAD/CAM",
              "Software utilizado: CAMWorks",
            ],
          },
          {
            title: "Diseño",
            structure: [
              "Relevamiento de piezas",
              "Diseño 2D/3D",
              "Software utilizado: SolidWorks",
            ],
          },
          {
            title: "Gestión de la producción",
            structure: [
              "Estimación de tiempos",
              "Carga horaria de máquinas",
              "Selección de procesos productivos",
              "Pedido de materiales",
              "Seguimiento",
              "Reportes de eficiencia",
              "Personas a cargo: 12",
            ],
          },
        ],
      },
    ],
  },
  EN: {
    Education: [
      {
        title: "The Odin Project - Full Stack Ruby on Rails",
        url: "https://www.theodinproject.com/paths/full-stack-ruby-on-rails?",
        start: "2020",
        end: "2021",
        area: "programming",
        list: [
          {
            title: "Skills",
            structure: ["Ruby/Rails", "HTML/CSS", "Javascript/NodeJs"],
          },
        ],
      },
      {
        title: "The Fundamentals of Database Engineering",
        url: "https://www.udemy.com/course/database-engines-crash-course/",
        start: "Jul 2023",
        end: "Ago 2023",
        area: "programming",
        list: [
          {
            title: "Skills",
            structure: [
              "ACID, Indexing, Partitioning, Sharding, Concurrency control, Replication, DB Engines, Best Practices",
            ],
          },
        ],
      },
      {
        title: "The Fundamentals of Backend",
        url: "https://www.udemy.com/share/107rGq3@UAyCjZcRsfXDZxTZVbto0WnAstH9dDLXIpN0gpKt3wfaeDMDiPH6-k8cH4xkxHt1qw==/",
        start: "Jun 2023",
        end: "Jul 2023",
        area: "programming",
        list: [
          {
            title: "Skills",
            structure: [
              "Understand backend communication design patterns, protocols, execution and proxying",
            ],
          },
        ],
      },
      {
        title: "AI Automation: Build LLM Apps & AI-Agents with n8n & APIs",
        url: "https://www.udemy.com/course/ai-automation-build-llm-apps-ai-agents-with-n8n-apis/?srsltid=AfmBOopEr3WXDAdCxJ2mk36YT9JF2RCqkQvrL_OBjCp7kF9jhJ7CDDdR",
        start: "Jun 2024",
        end: "Jul 2024",
        area: "programming",
        list: [
          {
            title: "Skills",
            structure: [
              "Fundamentals of Automation, n8n, API Integrations, LLM Apps Creation, AI-Agents Development",
            ],
          },
        ],
      },
      {
        title: "Ingeniería Mecánica - Universidad Tecnológica Nacional",
        start: "2007",
        end: "2014",
        description: "Cursado hasta 4to año de la carrera.",
        area: "mechanics",
        list: [
          {
            title: "Basics subjects approved",
            structure: [
              "Mathematical Analysis I y II",
              "Algebra and Analytical Geometry",
              "Advanced Calculus",
              "Physics I y II",
              "Probability and statistics",
              "General and Applied Chemistry",
            ],
          },
          {
            title: "Speciality subjects approved",
            structure: [
              "Mechanical Engeneering I, II y III",
              "Representation Systems",
              "Stability I",
              "Metalic Materials",
              "Environmental Eng and Industrial Safety",
              "Thermodinamycs",
              "Mechanical Design",
            ],
          },
        ],
      },
      {
        title:
          "Bachiller en Gestión de las Organizaciones - Colegio Santo Tomás",
        start: "1994",
        end: "2006",
        area: "school",
      },
    ],
    Experience: [
      {
        title: "Freelance - Fullstack Developer",
        start: "Jan 2025",
        end: "present",
        area: "programming",
        list: [
          {
            title: "Main Achievements",
            structure: [
              "Development of a Ruby on Rails application from scratch to manage industrial equipment and maintenance services",
              "Handling deployment, monitoring, and ongoing maintenance",
              "Direct work with stakeholders to gather requirements and iterate on features",
            ],
          },
        ],
      },
      {
        title: "GoCuotas - Backend Developer",
        start: "Feb 2024",
        end: "Nov 2024",
        area: "programming",
        list: [
          {
            title: "Main Achievements",
            structure: [
              "Implemented user lifecycle tracking (onboarding, active, inactive) for admin users",
              "Integrated and customized customer support chatbot flows based on user context",
              "Collaborated with product and support teams to improve user engagement",
            ],
          },
        ],
      },
      {
        title: "WISBOO - Backend Developer",
        start: "Sep 2022",
        end: "Jun 2023",
        area: "programming",
        list: [
          {
            title: "Main Achievements",
            structure: [
              "Improved API response times by up to 80/90% by optimizing database queries",
              "Identified performance bottlenecks and refactored critical parts of the application",
              "Used Datadog to analyze logs, errors and endpoint latency",
            ],
          },
        ],
      },
      {
        title: "Freelance - CNC Programmer / CAD/CAM Designer",
        start: "2017",
        end: "2021",
        area: "mechanics",
      },
      {
        title: "IMAPRO SRL / MetalCast - Plant manager",
        start: "2007",
        end: "2017",
        area: "mechanics",
        list: [
          {
            title: "CNC Programming",
            structure: [
              "Fagor CNC Mill",
              "Machined-based programming",
              "CAD/CAM Programming",
              "Software: CAMWorks",
            ],
          },
          {
            title: "Design",
            structure: ["Parts survey", "2D/3D Design", "Software: SolidWorks"],
          },
          {
            title: "Production managment",
            structure: [
              "Time estimation",
              "Hourly load of machines",
              "Production processes selection",
              "Materials ordering",
              "Dependents: 12",
              "Follow-up",
              "Efficiency reports",
              "Dependents: 12",
            ],
          },
        ],
      },
    ],
  },
};
